import { render, staticRenderFns } from "./ArrangeForm.vue?vue&type=template&id=0b939fdc"
import script from "./ArrangeForm.vue?vue&type=script&lang=js"
export * from "./ArrangeForm.vue?vue&type=script&lang=js"
import style0 from "./ArrangeForm.vue?vue&type=style&index=0&id=0b939fdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports